<template>
  <div>
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleSearch"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <ETableList :table-data="tableData" :table-label="tableLabel">
        <template #skuName="{ scope: { row } }">
          <eui-btn
            font-size="12"
            type="link"
            @click="goToUrl('/productDetail', { skuId: row.skuid })"
          >
            {{ row.skuname }}
          </eui-btn>
        </template>
        <template #stepPriceStatus="{ scope: { row } }">
          <el-switch
            v-if="row.stepPriceStatus"
            v-model="row.stepPriceStatus"
            :active-value="101"
            :inactive-value="102"
            @change="changeSwitch(row)"
          ></el-switch>
        </template>

        <template #tieredPrice="{ scope: { row } }">
          <eui-btn font-size="12" type="link" @click="openSetPrice(row, true)"
            >查看</eui-btn
          >
        </template>

        <template #operate="{ scope: { row } }">
          <eui-btn font-size="12" type="link" @click="openSetPrice(row, false)"
            >设置阶梯价</eui-btn
          >
        </template>
      </ETableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <set-price
      :set-price-visible.sync="setPriceVisible"
      :row-obj.sync="rowObj"
      :if-edit="ifEdit"
      @refreshList="refreshList"
    />
  </div>
</template>

<script>
import ESearch from '@/modules/projectA/components/common/e-search.vue';
import ETableList from '@/modules/projectA/components/common/e-table-list.vue';
import api from '../../api/product';
import SetPrice from './components/setPrice.vue';

export default {
  /* name: 'goodsMaintenance', */
  components: {
    SetPrice,
    ESearch,
    ETableList,
  },
  props: {},
  data() {
    return {
      ifEdit: false,
      minOrderQuantity: 1,
      rowObj: {},
      setPriceVisible: false,
      // 本页面参数
      filterInfo: {
        fieldList: [
          { label: '商品名称', type: 'input', value: 'skuname' },
          { label: '商品编号', type: 'input', value: 'skucode' },
        ],
        btnStyle: [
          { icon: 'el-icon-search', text: '搜索', type: 'primary' },
          { icon: 'el-icon-refresh', text: '重置' },
        ],
      },
      listTypeInfo: {
        typeList: [
          { id: 101, name: '已上架' },
          { id: 102, name: '已下架' },
        ],
      },
      idKey: 'skuId',
      // 列表搜索
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        skuName: '',
        skuCode: '',
        exportStatus: '',
        categoryName: '',
      },
      cloneListQuery: {},
      total: 0,
      tableLoading: false,
      tableData: [],
      tableLabel: [
        {
          label: '商品名称',
          align: 'center',
          minWidth: '320',
          slot: 'skuName',
        },
        {
          label: '商品编号',
          param: 'skucode',
          align: 'center',
          minWidth: '320',
        },
        {
          label: '起订量',
          param: 'minorderquantity',
          align: 'center',
          minWidth: '130',
        },
        {
          label: '阶梯价',
          align: 'center',
          slot: 'tieredPrice',
          minWidth: '160',
        },
        {
          label: '市场价(元)',
          param: 'price',
          align: 'center',
          minWidth: '130',
        },
        {
          label: '操作',
          align: 'center',
          slot: 'operate',
          width: '110',
        },
        {
          label: '阶梯价停启用',
          align: 'center',
          slot: 'stepPriceStatus',
          minWidth: '160',
        },
      ],
      // 选中的列表数据
      multipleSelection: [],
      multipleSelectionAll: [],
    };
  },
  created() {
    this.cloneListQuery = { ...this.listQuery };
    this.getAllList(this.listQuery);
  },
  methods: {
    // 获取全部接口
    async getAllList(params) {
      this.tableData = [];
      try {
        this.tableLoading = true;
        const { queryProductByPage } = api;
        const res = await queryProductByPage(params);
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.tableData = [...data.list];
          this.total = data.total;
        }
      } catch (err) {
        console.log(err);
      }
    },
    refreshList() {
      this.getAllList(this.listQuery);
    },
    async changeSwitch(row) {
      console.log(row);
      const {
        skuid: skuId,
        suppliercompanyid: supplierCompanyId,
        stepPriceStatus: status,
        price,
      } = row;
      /*
        101启用
        102停用
      */
      const res = await api.modifyStepPriceStatus({
        skuId,
        supplierCompanyId,
        status,
        price,
      });

      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    // 跳转链接
    goToUrl(url, row = {}) {
      const { skuId = '' } = row;
      this.$router.push({
        path: url,
        query: { skuId },
      });
    },
    // 设置阶梯价
    openSetPrice(row, ifEdit) {
      console.log(row);
      this.ifEdit = ifEdit;
      this.setPriceVisible = true;
      this.rowObj = { ...row };
    },
    // 修改市场价格 ｜｜
    async priceConfirmEdit(data, row) {
      const params = {
        skuId: row.skuId,
        price: Number(data),
      };
      const { updateSkuPrice } = api;
      const res = await updateSkuPrice(params);
      if (res.code !== '200') {
        this.getAllList(this.listQuery);
      }
    },
    clearTable() {
      this.multipleSelection = []; // 清空当前列表页选择的数据项
      this.multipleSelectionAll = []; // 清空已选择的数据项
      this.$refs.tableData.clearSelection(); // 清除全部的选中状态
    },

    //
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getAllList(this.listQuery);
    },
    // 改变条数
    handleSizeChange(val) {
      // 改变每页显示条数的时候调用一次
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getAllList(this.listQuery);
    },
    // 列表搜索
    handleSearch(val) {
      console.log(val);
      this.listQuery.pageNum = 1;
      Object.assign(this.listQuery, val);
      this.getAllList(this.listQuery);
    },
    // 列表搜索重置
    handleReset(val) {
      console.log(val);
      this.listQuery = { ...this.cloneListQuery };
      this.getAllList(this.listQuery);
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.create-product {
  .text-btn {
    color: #0263c9;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  ::v-deep .el-image {
    width: 48px;
    height: 48px;
    display: block;
    font-size: 0;
    ::v-deep img {
      display: block;
      width: 100%;
      width: 100%;
    }
  }
  .wrapper {
    margin-top: 20px;
    background: #fff;
  }
  .search-box {
    background: #fff;
    padding: 10px;
  }

  .handle-box {
    white-space: nowrap;
    background: #fff;
    margin-top: 20px;
    padding: 0 20px;
    min-height: 32px;
    .delete {
      color: #c5c5c5;
    }
  }
  .table-box {
    padding: 10px;
    overflow: hidden;
  }
  .pagination-box {
    text-align: right;
    margin-top: 10px;
  }
}
</style>
<style>
.el-tooltip__popper {
  max-width: 320px;
}
</style>
